export const api = {
  news: {
    list: "/api/icee_news/list",
    detail: "/api/icee_news/",
  },
  events: {
    list: "/api/icee_events/list",
    detail: "/api/icee_events/",
  },
  research: {
    list: "/api/icee_research/list",
    detail: "/api/icee_research/",
  },
  about_us: "/api/icee_common_data/?type=about_us",
  contact: "/api/icee_common_data/?type=contract_us",
  banners: "/api/icee_banners",
};
